export default __webpack_public_path__ + "locales/pt/SharingPanel.json?hash=f1cff7a50f397d7a1517a2add97f493c";